import { ImageIcon, PlusIcon } from './Icons';
import { useEffect, useState } from 'react';
import type { Product } from '../types/api';
import { resolveApiUrl } from '../services/api';
import ProductImage from './ProductImage';
import { getWeighableWarning, isWeighableProduct } from '../utils/product';
import './ProductCard.css';

interface Props {
  product: Product;
  isAuthenticated: boolean;
  onAddToCart?: (productId: string, productName: string, price: number, quantity?: number, weighable?: boolean) => void;
}

export default function ProductCard(props: Props) {
  const { product, onAddToCart } = props;
  const [imageSrc, setImageSrc] = useState(resolveApiUrl(product.image));
  const hasRealImage = Boolean(product.image) && !product.image.includes('product-placeholder.svg');
  const weighable = isWeighableProduct(product);

  useEffect(() => {
    setImageSrc(resolveApiUrl(product.image));
  }, [product.image]);

  return (
    <div className="product-card">
      <div className="product-card-image">
        {hasRealImage && imageSrc ? (
          <ProductImage
            src={imageSrc}
            alt={product.name}
            onFinalError={() => setImageSrc(resolveApiUrl('/api/assets/product-placeholder.svg'))}
          />
        ) : (
          <div className="product-card-placeholder" aria-hidden="true">
            <div className="product-card-placeholder-badge">VM</div>
            <ImageIcon size={22} />
            <strong>{product.category || 'Catalogo'}</strong>
            <span>Imagem em atualizacao</span>
          </div>
        )}
      </div>
      <div className="product-card-body">
        <span className="product-card-category">{product.category}</span>
        <p className="product-card-name">{product.name}</p>
        <p className="product-card-code">Ref. {product.code}</p>
        <div className="product-card-footer">
          {product.price != null ? (
            <span className="product-card-price">
              {product.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          ) : <span className="product-card-price-hidden">Preco indisponivel</span>}
          <button
            className="product-card-add"
            disabled={!product.available}
            onClick={() => onAddToCart?.(product.id, product.name, product.price || 0, 1, weighable)}
            aria-label="Adicionar ao carrinho"
            type="button"
          >
            <PlusIcon size={18} />
          </button>
        </div>
        {weighable && <p className="product-card-warning">{getWeighableWarning()}</p>}
      </div>
    </div>
  );
}
